// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__vqq5G","selects":"Documents_selects__1MLfV"};